/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'zsd-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.scss']
})
export class FileUploadComponent implements OnInit {
  public fileList: Array<File> = [];
  fileSizeCheck = true;
  attachmentLabel = 'Attachment:';
  dragAndDropLabel = 'Drag and Drop here';
  @Output() private filesSelected: EventEmitter<File[]> = new EventEmitter();
  @Output() private isformValid: EventEmitter<boolean> = new EventEmitter();

  constructor(public http: HttpClient) { }

  ngOnInit() {
    this.isformValid.emit(true);
  }

  onFilesChange(fileList: Array<File>) {
    const newFileList = [];
    for (let i = 0; i < this.fileList.length; i++) {
      newFileList.push(this.fileList[i]);
    }
    for (let i = 0; i < fileList.length; i++) {
      newFileList.push(fileList[i]);
    }
    this.fileList = newFileList;
    this.filesSelected.emit(this.fileList);
    (<HTMLInputElement>document.getElementById('file')).value = '';

  }

  removeFile(index) {
    const newFileList = [];
    this.fileSizeCheck = true;
    for (let i = 0; i < this.fileList.length; i++) {
      if (i !== index) {
        newFileList.push(this.fileList[i]);
        if ((this.fileList[i].size) / (1024 * 1024) > 100) {
          this.fileSizeCheck = false;
        }
      }
    }
    this.fileList = newFileList;
    this.filesSelected.emit(this.fileList);
    this.isformValid.emit(this.fileSizeCheck);

  }


  selectFile() {
    let element: HTMLElement = document.getElementById('file') as HTMLElement;
    element.click();
  }

  isFileSizeExceeded(index) {
    for (let i = 0; i < this.fileList.length; i++) {
      if (i === index) {
        if ((this.fileList[i].size) / (1024 * 1024) > 100)  {
          this.isformValid.emit(false);
          return true;

        }
      }
    }
    return false;
  }

  isFilenameSizeWithinLimit(index) {
    for (let i = 0; i < this.fileList.length; i++) {
      if (i === index) {
        if (this.fileList[i].name.length < 52) {
          return true;
        }
      }
    }
    return false;
  }
  trackByfile(index) {
    return index;
  }

}
